import { CourseRelevantExecution } from './course-relevant-execution.model';

export class CourseRelevantExecutionCommand {
    constructor(tempTap: CourseRelevantExecution) {}
}
